import React, { useState, useEffect } from "react";
import Badge from '@mui/material/Badge';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Popover from '@mui/material/Popover';
import Stack from '@mui/material/Stack';
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import RestartAltRoundedIcon from '@mui/icons-material/RestartAltRounded';
import "./Search.scss";
import { useLocation } from 'react-router-dom';
import ProductStore from 'services/store/ProductStore';

const Search = ({ token }) => {
  const [search, setSearch] = useState("");
  const [min, setMin] = useState("");
  const [max, setMax] = useState("");
  const [color, setColor] = useState("");
  const [hasOption, setHasOption] = useState(false);
  const [filtersAnchorEl, setFiltersAnchorEl] = useState(null);
  const location = useLocation();

  useEffect(() => {
    setHasOption(min || max || color);
  }, [min, max, color]);

  const searchAction = (event) => {
    event.preventDefault();
    setFiltersAnchorEl(null);
    ProductStore.currentPage = 1;
    ProductStore.searchProducts(token, search, min, max, color);
  };

  const openFilters = (event) => {
    setFiltersAnchorEl(event.currentTarget);
  };

  const closeFilters = () => {
    setFiltersAnchorEl(null);
  };

  const resetFilters = () => {
    setMin("");
    setMax("");
    setColor("");
  };

  if (location.pathname !== "/products" ) return null;

  const isFiltersOpen = Boolean(filtersAnchorEl);

  return (
    <div>
      <Box component="form" className="search-form" onSubmit={searchAction}>
        <Badge
          color="error"
          variant="dot"
          overlap="circular"
          invisible={!hasOption}
          className="search-filter-badge"
        >
          <IconButton
            type="button"
            className="search-filter-button"
            onClick={openFilters}
            aria-expanded={isFiltersOpen ? 'true' : 'false'}
            aria-label="Ouvrir les filtres"
          >
            <TuneRoundedIcon fontSize="small" />
          </IconButton>
        </Badge>
        <TextField
          size="small"
          fullWidth 
          id="search" 
          label="Rechercher" 
          variant="outlined" 
          value={search}
          margin="dense"
          className="search-input"
          onChange={e => setSearch(e.target.value)}/>
        <IconButton type="submit" className="search-submit-button" aria-label="Lancer la recherche">
          <SearchRoundedIcon fontSize="small" />
        </IconButton>
        <Popover
          open={isFiltersOpen}
          anchorEl={filtersAnchorEl}
          onClose={closeFilters}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top', horizontal: 'left' }}
          PaperProps={{
            className: 'search-popover',
            sx: {
              mt: 1,
              width: 360,
              maxWidth: 'calc(100vw - 24px)',
              borderRadius: 3,
              boxShadow: (theme) => theme.shadows[8],
              border: (theme) => `1px solid ${theme.palette.divider}`,
            },
          }}
        >
          <Stack className="search-popover-content" spacing={2}>
            <div className="search-popover-header">
              <strong>Filtres</strong>
              <Button
                type="button"
                variant="text"
                size="small"
                startIcon={<RestartAltRoundedIcon fontSize="small" />}
                onClick={resetFilters}
                sx={{ textTransform: 'none' }}
              >
                Réinitialiser
              </Button>
            </div>

            <div className="search-length">
              <span>Longueur</span>
            <TextField
              size="small" 
              id="lengthMin" 
              label="Min (cm)" 
              variant="outlined" 
              value={min}
              margin="dense"
              onChange={e => setMin(e.target.value)}/>
            <TextField
              size="small" 
              id="lengthMax" 
              label="Max (cm)" 
              variant="outlined" 
              value={max}
              margin="dense"
              onChange={e => setMax(e.target.value)}/>
            </div>

            <TextField
              id="color"
              select
              label="Couleur"
              margin="dense"
              fullWidth
              size="small"
              defaultValue={""}
              value={color}
              onChange={e => setColor(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end" className="clear" onClick={() => setColor("")}>
                    {color && (
                      <CloseRoundedIcon fontSize="small" />
                    )}
                  </InputAdornment>
                )
              }}
              >
                <MenuItem value={"3"}>Blanc</MenuItem>
                <MenuItem value={"1"}>Bleu</MenuItem>
                <MenuItem value={"45"}>Chocolat</MenuItem>
                <MenuItem value={"47"}>Crème</MenuItem>
                <MenuItem value={"95"}>Grenat</MenuItem>
                <MenuItem value={"7"}>Jaune</MenuItem>
                <MenuItem value={"34"}>Mauve</MenuItem>
                <MenuItem value={"8"}>Mix</MenuItem>
                <MenuItem value={"96"}>Noir</MenuItem>
                <MenuItem value={"6"}>Orange</MenuItem>
                <MenuItem value={"96"}>Noir</MenuItem>
                <MenuItem value={"35"}>Parme</MenuItem>
                <MenuItem value={"4"}>Rose</MenuItem>
                <MenuItem value={"2"}>Rouge</MenuItem>
                <MenuItem value={"23"}>Saumon</MenuItem>
                <MenuItem value={"9"}>Varié</MenuItem>
                <MenuItem value={"5"}>Vert</MenuItem>
            </TextField>
            <div className="search-popover-actions">
              <Button type="button" variant="outlined" onClick={closeFilters} sx={{ textTransform: 'none' }}>
                Fermer
              </Button>
              <Button type="button" variant="contained" onClick={searchAction} sx={{ textTransform: 'none' }}>
                Rechercher
              </Button>
            </div>
          </Stack>
        </Popover>
      </Box>
    </div>
  );
};

export default Search;
